var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeInRight",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "container",
    attrs: {
      "enter-active-area": "animated fadeIn"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h1', {
    staticClass: "text-center about-us-heading"
  }, [_vm._v("Reports")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://drive.google.com/open?id=0Bx8HCAUydkPkOEk2YlA2RDdQLU0"
    }
  }, [_vm._v("Click Here for our Annual Report 2013-2014")])])]), _vm._v(" "), _c('hr')])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10282af9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reports.vue
// module id = iLVK
// module chunks = 0